import type { i18n as I18n } from "i18next";
import en from "@/locales/en/puzzle-types/masyu.json";
import fr from "@/locales/fr/puzzle-types/masyu.json";

export const MASYU_NS = "puzzle-types/masyu";

/** Adds this type's translations to an initialised i18next instance (idempotent). */
export function registerMasyuTranslations(i18n: I18n): void {
  if (!i18n.hasResourceBundle("en", MASYU_NS))
    i18n.addResourceBundle("en", MASYU_NS, en, true, true);
  if (!i18n.hasResourceBundle("fr", MASYU_NS))
    i18n.addResourceBundle("fr", MASYU_NS, fr, true, true);
}
